export interface iExchangeCode {
  cnt: number | null;
  value: number | null;
  expire_at: Date | number | null;
  name: string;
}

export interface iCodeModel {
  version: string;
  name: string;
  user: string;
}
export interface iCodeQuery extends iCodeModel {
  page: number;
  page_size: number;
}
export interface iAdparams {
  app_id: string;
  advs: {
    idx: string;
    idx_name: string;
    pos: string;
    pos_name: string;
    img?: string;
    main_title: string;
    sub_title?: string;
    link?: string;
    extend?: string;
    op_type: string;
    disable?: boolean;
    default_show?: boolean;
    grade_type?: number;
    grade_id?: number;
  }[];
}
export interface iImagesList {
  id: string;
  position: string;
  positionValue: string;
  subtitle?: string;
  imageUrl: string;
  uploadSizeType?: string;
  isClass?: boolean;
  fillText?: {
    title: string;
    value: any;
    placeholder: string;
    isRelevance?: boolean; //是否关联
    max?: number;
    type?: eInputType | eInputType.INPUT;
    childrens?: { label: string; value: string }[];
    checked?: boolean;
    filterable?: boolean;
  }[];
  extend?: iExtend;
  uploadText?: string;
}
export interface iMyPageList {
  linkState: string;
  imageUrl: string;
  appid: string;
  website: string;
  width: number;
  height: number;
  bannerId: string;
  bannerSize: string;
  bannerLoop: false;
  grade_type: number;
  grade_id: number;
}
export interface iTextList {
  title: string;
  value: any;
  placeholder: string;
  max?: number;
}
/* 扩展 */
export interface iExtend {
  game_id?: number;
  isRelevance?: boolean;
  file_id?: number;
}
/* 虚拟键盘 */
export interface iChannelTotal {
  type: string;
  uv: number;
  register: number;
  recharge: number;
}
export interface iChannelDetails {
  name: string;
  uv: number;
  register: number;
  recharge: number;
  opt_user: string;
  created_at: number;
  link: string;
  code: string;
  coin: number;
}
export interface iChannelSearch {
  start: number;
  end: number;
  channel_name: string;
  opt_user: string;
  channel_type: string;
  page: number;
  page_size: number;
}
export interface iTimeParams {
  start: number;
  end: number;
}
export enum eInputType {
  /* 输入框 */
  INPUT = 0,
  /* 单选框 */
  RADIO = 1,
  /* 下拉框 */
  SELECT = 2,
  /* 复选框 */
  CHECKBOX = 3,
  /* 文本 */
  LABEL = 4,
}

export enum eOpenState {
  /** 输入框 */
  OPEN = 1,
  /** 关闭 */
  CLOSE = 0,
}
